const Helper = {
    getMaxDimensions(id) {
        const val = {}
        const container = document.getElementById(id)
        val.w = container.offsetWidth
        val.h = container.offsetHeight

        val.w >= val.h ? (val.max = val.h) : (val.max = val.w)
        val.w >= val.h
            ? (val.direction = "horizontal")
            : (val.direction = "vertical")

        return val
    },

    getScreenCoords(x, y, ctm) {
        const xn = ctm.e + x * ctm.a + y * ctm.c
        const yn = ctm.f + x * ctm.b + y * ctm.d
        return { x: xn, y: yn }
    },

    getScreenCoordsCanvas(x, y, ctm) {
        const xn = ctm.x + x*ctm.s
        const yn = ctm.y + y*ctm.s
        return { x: xn, y: yn }
    },

    async loadImage(imageUrl) {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.addEventListener("load", () => resolve(img))
            img.addEventListener("error", err => reject(err))
            img.src = imageUrl
        })
    },

}

export default Helper
